"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTabState = exports.usePanelState = exports.Tabs = exports.Tab = exports.Panel = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useConstant = _interopRequireDefault(require("use-constant"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

//source file for @bumaga/tabs at https://www.npmjs.com/package/@bumaga/tabs
//fix for duplicate tabs is added from https://github.com/jeetiss/tabs/pull/220
var TabsState = /*#__PURE__*/(0, _react.createContext)();
var Elements = /*#__PURE__*/(0, _react.createContext)(); // eslint-disable-next-line

var Tabs = function Tabs(_ref) {
  var outerState = _ref.state,
      children = _ref.children;
  var innerState = (0, _react.useState)(0);
  var elements = (0, _useConstant.default)(function () {
    return {
      tabs: [],
      panels: []
    };
  });
  var state = outerState || innerState;
  return /*#__PURE__*/_react.default.createElement(Elements.Provider, {
    value: elements
  }, /*#__PURE__*/_react.default.createElement(TabsState.Provider, {
    value: state
  }, children));
};

exports.Tabs = Tabs;

var useTabState = function useTabState(children) {
  var _useContext = (0, _react.useContext)(TabsState),
      _useContext2 = (0, _slicedToArray2.default)(_useContext, 2),
      activeIndex = _useContext2[0],
      setActive = _useContext2[1];

  var elements = (0, _react.useContext)(Elements);
  var tabIndex = (0, _useConstant.default)(function () {
    var currentIndex = elements.tabs.length;
    var childrenIndex = elements.tabs.indexOf(children);
    var isChildrenUnique = !elements.tabs.includes(children);

    if (isChildrenUnique) {
      elements.tabs.push(children);
    }

    return isChildrenUnique ? currentIndex : childrenIndex;
  });
  var onClick = (0, _useConstant.default)(function () {
    return function () {
      return setActive(tabIndex);
    };
  });
  var state = (0, _react.useMemo)(function () {
    return {
      isActive: activeIndex === tabIndex,
      onClick: onClick
    };
  }, [activeIndex, onClick, tabIndex]);
  return state;
};

exports.useTabState = useTabState;

var usePanelState = function usePanelState(children) {
  var _useContext3 = (0, _react.useContext)(TabsState),
      _useContext4 = (0, _slicedToArray2.default)(_useContext3, 1),
      activeIndex = _useContext4[0];

  var elements = (0, _react.useContext)(Elements);
  var panelIndex = (0, _useConstant.default)(function () {
    var currentIndex = elements.panels.length;
    var childrenIndex = elements.panels.indexOf(children);
    var isChildrenUnique = !elements.panels.includes(children);

    if (isChildrenUnique) {
      elements.panels.push(children);
    }

    return isChildrenUnique ? currentIndex : childrenIndex;
  });
  return panelIndex === activeIndex;
};

exports.usePanelState = usePanelState;

var Tab = function Tab(_ref2) {
  var children = _ref2.children;
  var state = useTabState(children);

  if (typeof children === 'function') {
    return children(state);
  }

  return /*#__PURE__*/(0, _react.isValidElement)(children) ? /*#__PURE__*/(0, _react.cloneElement)(children, state) : children;
};

exports.Tab = Tab;

var Panel = function Panel(_ref3) {
  var active = _ref3.active,
      children = _ref3.children;
  var isActive = usePanelState(children);
  return isActive || active ? children : null;
};

exports.Panel = Panel;